import { render, staticRenderFns } from "./FormSetupGrid.vue?vue&type=template&id=00efae50"
import script from "./FormSetupGrid.vue?vue&type=script&lang=js"
export * from "./FormSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports